import React, { useEffect, useState } from 'react';
import { config } from '../config';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useNotification } from '../components/Notification';
import Spinner from '../components/Spinner';
import './VerifyEmail.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Kein Bestätigungstoken gefunden.');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const response = await fetch(`${config.API_URL || 'https://api.garagedesk.net/api'}/auth/verify-email?token=${encodeURIComponent(token)}`);
      
      if (!response.ok) {
        const errorData = await response.json();
        setStatus('error');
        setMessage(errorData.error || 'Fehler bei der E-Mail-Bestätigung');
        return;
      }

      const data = await response.json();
      setStatus('success');
      setMessage(data.message || 'E-Mail-Adresse erfolgreich bestätigt!');
      showNotification('E-Mail-Adresse erfolgreich bestätigt!', 'success');
      
      setTimeout(() => {
        navigate('/login?verified=true');
      }, 3000);
    } catch (error) {
      setStatus('error');
      setMessage('Fehler bei der E-Mail-Bestätigung. Bitte versuchen Sie es erneut.');
    }
  };

  if (status === 'verifying') {
    return (
      <div className="verify-email-container">
        <div className="verify-email-box">
          <Spinner />
          <p>E-Mail-Adresse wird bestätigt...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-email-container">
      <div className="verify-email-box">
        <div className={`verify-icon ${status === 'success' ? 'success' : 'error'}`}>
          {status === 'success' ? '✅' : '❌'}
        </div>
        <h2>{status === 'success' ? 'Bestätigung erfolgreich!' : 'Bestätigung fehlgeschlagen'}</h2>
        <p className="verify-message">{message}</p>
        {status === 'success' ? (
          <p className="verify-redirect">Sie werden in Kürze zur Anmeldeseite weitergeleitet...</p>
        ) : (
          <button 
            className="btn-primary" 
            onClick={() => navigate('/login')}
          >
            Zur Anmeldeseite
          </button>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;

